/**
 * RGV buy-path overlays — Sighted Pareto #2 (2026-09-12)
 *
 * On product + collection templates:
 *  1. Defer first-paint email/promo modals until engagement (scroll, pointer,
 *     key, or 45s). Edge tabs stay available but are repositioned via CSS.
 *  2. Strip ghost full-viewport overlays left behind after dismiss
 *     (known EcomSend / react-responsive-modal failure mode).
 *  3. Mirror sticky-ATC body class for CSS clearance helpers.
 */
(function () {
  'use strict';

  var BUY_PATH = /(^|\s)template-(product|collection)(\s|$)/;
  if (!BUY_PATH.test(document.body.className)) return;

  var DEFER_MS = 45000;
  var root = document.documentElement;
  var engaged = false;
  var timer = null;

  function markEngaged() {
    if (engaged) return;
    engaged = true;
    root.classList.remove('rgv-defer-overlays');
    root.classList.add('rgv-overlays-ready');
    ['scroll', 'wheel', 'touchstart', 'pointerdown', 'keydown'].forEach(function (evt) {
      window.removeEventListener(evt, markEngaged, true);
    });
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  }

  // Start deferred: hide modal roots via CSS until engagement.
  root.classList.add('rgv-defer-overlays');
  ['scroll', 'wheel', 'touchstart', 'pointerdown', 'keydown'].forEach(function (evt) {
    window.addEventListener(evt, markEngaged, { capture: true, passive: true, once: true });
  });
  timer = setTimeout(markEngaged, DEFER_MS);

  // Sticky ATC body flag (theme.js owns show/hide; CSS uses this for clearance).
  function syncStickyFlag() {
    var sticky = document.querySelector('.stickyCart');
    var open = !!(sticky && sticky.offsetParent !== null && window.getComputedStyle(sticky).display !== 'none');
    document.body.classList.toggle('rgv-sticky-atc-active', open);
  }
  window.addEventListener('scroll', syncStickyFlag, { passive: true });
  window.addEventListener('resize', syncStickyFlag, { passive: true });
  setInterval(syncStickyFlag, 500);

  // Ghost overlay sweeper — remove pointer-blocking shells with no dialog.
  var OVERLAY_SEL = [
    '.react-responsive-modal-overlay',
    '.react-responsive-modal-root',
    '.pp-overlay',
    '.mfp-bg',
    '[class*="ecomsend"][class*="overlay" i]',
    '[class*="EcomSend"][class*="Overlay"]'
  ].join(',');

  function isVisible(el) {
    if (!el) return false;
    var style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) {
      return false;
    }
    var rect = el.getBoundingClientRect();
    return rect.width > 2 && rect.height > 2;
  }

  function looksLikeDialog(el) {
    if (!el) return false;
    if (el.getAttribute('role') === 'dialog' || el.getAttribute('aria-modal') === 'true') return true;
    var cls = (el.className || '').toString();
    return /modal|dialog|popup|mfp-content|pp-modal/i.test(cls);
  }

  function sweepGhostOverlays() {
    document.querySelectorAll(OVERLAY_SEL).forEach(function (el) {
      if (!isVisible(el)) return;
      // If this node (or its root) has no visible dialog descendant, kill hit-testing.
      var rootEl = el.closest('.react-responsive-modal-root, .mfp-wrap, .pp-modal, [class*="Modal"]') || el;
      var dialogs = rootEl.querySelectorAll('[role="dialog"], [aria-modal="true"], .mfp-content, .pp-modal, [class*="modal" i], [class*="Modal"]');
      var anyDialog = false;
      dialogs.forEach(function (d) {
        if (looksLikeDialog(d) && isVisible(d)) anyDialog = true;
      });
      // Magnific open state
      if (document.body.classList.contains('mfp-zoom-out-cur') || document.body.classList.contains('mfp-ready')) {
        anyDialog = anyDialog || !!document.querySelector('.mfp-content');
      }
      if (!anyDialog) {
        el.style.pointerEvents = 'none';
        // If it covers the full viewport and has no content, hide entirely.
        var rect = el.getBoundingClientRect();
        var covers =
          rect.top <= 0 &&
          rect.left <= 0 &&
          rect.bottom >= (window.innerHeight || 0) - 2 &&
          rect.right >= (window.innerWidth || 0) - 2;
        if (covers && !el.querySelector('input, button, a, form, iframe')) {
          el.style.display = 'none';
          el.setAttribute('data-rgv-ghost-overlay', 'stripped');
        }
      }
    });
  }

  // Observe DOM mutations from the popup app.
  var moTimer = null;
  var observer = new MutationObserver(function () {
    if (moTimer) return;
    moTimer = setTimeout(function () {
      moTimer = null;
      sweepGhostOverlays();
    }, 100);
  });
  observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });

  // Also sweep on engagement + periodic light poll for the first minute.
  markEngaged && null;
  window.addEventListener('rgv:overlays-ready', sweepGhostOverlays);
  var polls = 0;
  var pollId = setInterval(function () {
    sweepGhostOverlays();
    polls += 1;
    if (polls > 30) clearInterval(pollId);
  }, 2000);
})();
